import { CONTENT_PLACEHOLDER } from 'my-purchases/constants/constants'
import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import type { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import { PRODUCT_STATUS } from 'my-purchases/constants/productStatus'
import type { Order } from 'my-purchases/types/purchaseList'

import { getBOPOKey } from './getBOPOKey'

interface GetStatusDescriptionProps {
	paymentMethod: PAYMENT_TYPES
	isActive: boolean
	order: Order
}

export function getStatusDescription({
	paymentMethod,
	order,
}: GetStatusDescriptionProps) {
	const { returnedItemsCount, nextToDelivery, status, lines } = order

	const cancellationStatuses = [
		ORDER_STATUS.cancelled,
		ORDER_STATUS.cancellation_in_progress,
		ORDER_STATUS.refunded,
	]

	const hasSomeReturnRequested = lines?.some(
		(line) => line?.status === PRODUCT_STATUS.RETURN_REQUESTED
	)

	if (hasSomeReturnRequested) {
		return { statusMessage: 'myPurchases.online.status_return_requested.label' }
	}

	if (returnedItemsCount > 1) {
		return { statusMessage: 'myPurchases.online.returnedItems.label' }
	}

	if (returnedItemsCount === 1) {
		return { statusMessage: 'myPurchases.online.oneReturnedItem.label' }
	}

	if (
		cancellationStatuses.includes(status) ||
		(status === ORDER_STATUS.shipped && nextToDelivery)
	) {
		return null
	}

	const bopoKey = getBOPOKey(status, paymentMethod)

	return {
		statusMessage: status
			? `myPurchases.online.mobile.details.status_${status}.subtitle${bopoKey}`
			: CONTENT_PLACEHOLDER,
	}
}
